import _ from 'lodash';
import { parse, differenceInYears, isAfter, isBefore, isValid } from 'date-fns';

export const nameRegex = /^[a-z '-]+$/i;
const addressRegex = /^[a-zA-Z0-9/@' .,#\-\\:;]+$/i;
const cityRegex = /^[0-9]*[a-zA-Z]+[a-zA-Z0-9 '.\-,]+$/i;
const zipRegex = /^\d{5}(-?\d{4})?$/i;
const phoneNumberRegex = /^\d{10}$/i;
const minAgeRequired = 13;

export const isEmptyString = (str: string): boolean =>
  str.replace(/\W/g, '').length === 0;

export const isNameValid = (str: string): boolean =>
  _.isString(str) && nameRegex.test(str) && !isEmptyString(str);

const validDateFormats = [
  'yyyy-MM-dd',
  'MM/dd/yyyy',
  'M/dd/yyyy',
  'M/d/yyyy',
  'M / d / yyyy',
  'MM / dd / yyyy',
];

const parseDate = (dateString: string): Date | null => {
  for (const format of validDateFormats) {
    const parsedDate = parse(dateString, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }
  return null;
};

export const isBirthdayValid = (str: string): boolean => {
  const parsedDate = parseDate(str);
  return (
    parsedDate !== null &&
    isAfter(parsedDate, new Date(1899, 11, 31)) &&
    isBefore(parsedDate, new Date())
  );
};

export const isAtLeastAge = (str: string): boolean => {
  const parsedDate = parseDate(str);
  return (
    parsedDate && differenceInYears(new Date(), parsedDate) >= minAgeRequired
  );
};

export const isAddressValid = (str: string): boolean =>
  addressRegex.test(str) && !isEmptyString(str);

export const isCityValid = (str: string): boolean => cityRegex.test(str);

export const isZipcodeValid = (str: string): boolean => zipRegex.test(str);

export const isPhoneNumberValid = (str: string): boolean =>
  phoneNumberRegex.test(str.replace(/\D/g, ''));
